import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DrfList } from '@shared/models/drf-response.models';
import { apiUrl } from '../http/api.constant';
import { API_URL } from '@shared/service/api.constant';
import { ApiService } from '@core/http/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    private httpAuth: ApiService,
  ) {}

  getAll() {
    return this.http.get<DrfList>(apiUrl.users);
  }

  getViewUrlByType(
    type: string,
    s11DocumentNumber: string,
  ): Observable<{ codium_memo_url: string }> {
    const url =
      type === 'pre-approve'
        ? API_URL.pre_approve_memo +
          'view-url/?s11_document_number=' +
          s11DocumentNumber
        : API_URL.s11_contract +
          'view-url/?s11_document_number=' +
          s11DocumentNumber;
    return this.httpAuth.get<{ codium_memo_url: string }>(url);
  }
}
